import { render, staticRenderFns } from "./dashboardDetail.vue?vue&type=template&id=7a02fa80&"
import script from "./dashboardDetail.vue?vue&type=script&lang=js&"
export * from "./dashboardDetail.vue?vue&type=script&lang=js&"
import style0 from "./dashboardDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports